import { Flex, Typography, Button, Icons } from 'components';
import { useAlert } from 'features/alert';
import { ReactElement } from 'react';
import styled from 'styled-components';

interface ConfirmationProps {
  recoveryCode: string;
  onClick: () => void;
}

const ButtonConfirmation = styled(Button)`
  ${({ theme: { mediaQueries } }) => {
    return `
    width: 100%;

      ${mediaQueries.desktop} {
        width: 100%;
      }
    `;
  }}
`;
const Icon = styled(Icons)`
  width: 16px;
  height: 16px;
  margin-left: 16px;
`;

const IconInfo = styled(Icons)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.gray_300};
  margin-right: 8px;
`;

const Confirmation = ({ onClick, recoveryCode }: ConfirmationProps): ReactElement => {
  const { setAlert } = useAlert();

  const handleCopyClick = () => {
    navigator.clipboard
      .writeText(recoveryCode)
      .then(() => {
        setAlert({
          type: 'success',
          message: 'Código copiado com sucesso..',
        });
      })
      .catch((err) => {
        setAlert({
          type: 'error',
          message: 'Ocorreu um erro ao tentar copiar o código. Por favor, tente novamente.',
        });
      });
  };

  return (
    <Flex alignSelf="center" flexDirection="column" padding={24} justifyContent="space-between" maxWidth={600} backgroundColor="white">
      <Flex justifyContent="center">
        <Flex marginBottom={16} justifyContent="center">
          <Typography fontWeight="bold" color="dark_350" textAlign="center">
            A autenticação em dois fatores foi configurada
          </Typography>
        </Flex>
        <Flex maxWidth={530} justifyContent="center">
          <Flex marginBottom={32} justifyContent="center">
            <Typography type="type1" color="dark_350" textAlign="center">
              Sempre que você fizer login, acesse o aplicativo autenticador e informe o código de 6 dígitos que aparecerá para a sua conta da MELVER.
            </Typography>
          </Flex>
        </Flex>
        <Flex maxWidth={500} padding={16} border="1px solid #D9D9D9" borderRadius={4}>
          <Flex flexDirection="column">
            <Flex>
              <Flex marginBottom={16}>
                <Typography fontWeight="bold" color="dark_350">
                  Seu código de recuperação
                </Typography>
              </Flex>
              <Flex marginBottom={32}>
                <Typography type="type1" color="dark_350">
                  Caso você perca acesso ao seu celular atual, você pode usar o código de recuperação abaixo.
                  <Typography type="type1" color="dark_350" fontWeight="bold">
                    Atenção! Este código é gerado apenas uma única vez.
                  </Typography>
                </Typography>
              </Flex>
              <Flex flexDirection="column" alignItems="center" justifyContent="center">
                <Flex marginBottom={24}>
                  <Typography fontWeight="bold" type="type2" color="primary_400">
                    {recoveryCode}
                  </Typography>
                </Flex>

                <Flex>
                  <ButtonConfirmation
                    outline
                    type="button"
                    p={24}
                    height={48}
                    bg="primary_400"
                    color="white"
                    colorHover="white"
                    size="small"
                    onClick={() => handleCopyClick()}
                  >
                    Copiar código de recuperação
                    <Icon icon="copy" />
                  </ButtonConfirmation>
                </Flex>

                <Flex flexDirection="row" flexWrap="nowrap" alignItems="flex-start" marginTop={48}>
                  <IconInfo icon="info" style={{ flexShrink: 0 }} />

                  <Flex maxWidth={430}>
                    <Typography type="type1" color="light4">
                      Nunca solicitamos códigos por telefone ou aplicativos de mensagem. Não compartilhe seu código com outras pessoas.
                    </Typography>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      {/** 
       * TODO FAZER QUANDO A WIKI ESTIVER PRONTA
       * <Flex marginY={32} justifyContent="center">
        <Link to={``}>
          <Typography fontWeight="bold" type="type1" color="primary_400">
            Dúvidas sobre a autenticação em dois fatores? Acesse o FAQ
          </Typography>
        </Link>
      </Flex> */}

      <Flex justifyContent="center" marginTop={32}>
        <Button maxWidth={197} type="button" p={24} bg="primary_400" color="white" colorHover="white" size="small" onClick={onClick}>
          Confirmar código
        </Button>
      </Flex>
    </Flex>
  );
};

export default Confirmation;
